import React from "react";
import { useHistory } from "react-router";
import { Button } from "../BP2Components";

import SettingsModal from "components/Modal/SettingsModal";
import Forms from "../FormsV2/FormComplete";

import "./actionsDropdown.less";

//DEPRACATED, used only in basket
const ActionModal = ({ action, props, onlyItem }) => {
   const history = useHistory();

   return action?.redirectUrl && props?.row ? (
      onlyItem ? (
         <Button
            buttonType="primary"
            onClick={() => {
               if (props.isUserLoggedIn == false) {
                  history.push("/signin");
               }
            }}
         >
            {action?.label}
         </Button>
      ) : (
         <a
            onClick={() => {
               if (props.isUserLoggedIn == false) {
                  history.push("/signin");
               }
            }}
            className="ant-btn-primary"
         >
            {action?.label}
         </a>
      )
   ) : (
      !action?.cloudConnections && (
         <>
            <SettingsModal
               customAvatar={
                  onlyItem ? (
                     <Button
                        buttonType="primary"
                        onClick={() => {
                           if (props.isUserLoggedIn == false) {
                              history.push("/signin");
                           }
                        }}
                     >
                        {action?.label}
                     </Button>
                  ) : (
                     <a
                        onClick={() => {
                           if (props.isUserLoggedIn == false) {
                              history.push("/signin");
                           }
                        }}
                     >
                        {action?.label}
                     </a>
                  )
               }
               title={action?.label}
               children={
                  <Forms
                     formId={action?.formID}
                     dataId={props.row?._sysRecordId ?? props.row?.api_rowMetaData.recordId}
                     printable
                     submitVisible
                     actionId={action.id}
                     recordId={props.row?._sysRecordId ?? props.row?.api_rowMetaData.recordId}
                  />
               }
            />
         </>
      )
   );
};

export default ActionModal;
